module.exports = __webpack_public_path__ + "img/16d011-28.f2f6459a.png";